<template>
  <div class="param-manage">
    <!-- 条件搜索部分 -->
    <el-form class="zwx-form" key="mainForm" ref="mainForm" :model="mainForm" label-position="right"
             @submit.native.prevent>
      <div class="self-adapting-condition">
        <el-form-item  label="参数名称：">
          <el-input class="zwx-input" v-model="mainForm.parameterKeyLike" placeholder="请输入"
                    @keyup.enter.native="search(1)" clearable />
        </el-form-item>
        <el-form-item  label="状态：">
          <el-checkbox-group class="zwx-checkbox-group" v-model="mainForm.ifEnables">
            <el-checkbox class="zwx-checkbox" :label="true">启用</el-checkbox>
            <el-checkbox class="zwx-checkbox" :label="false">停用</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <div class="condition-button-row">
          <el-button class="zwx-button zwx-button-icontext-28" type="primary" icon="el-icon-search" @click="search(1)">
            查询
          </el-button>
          <el-button class="zwx-button zwx-button-icontext-28" icon="el-icon-plus" @click="add()">添加
          </el-button>
        </div>
      </div>
    </el-form>
    <!-- 列表展示部分 -->
    <el-table class="zwx-table" height=" calc(100vh - 152px)" row-key="rid" :data="dataList" border stripe>
      <el-table-column prop="parameterKey" label="参数名称"
                       :width="$system.calWidth(dataList, 'parameterKey', '参数名称')"
                       header-align="left" align="left"></el-table-column>
      <el-table-column prop="parameterType" label="参数类型"
                       :width="$system.calWidth(dataList, 'parameterType', '参数类型')"
                       header-align="left" align="center" :formatter="parameterTypeFormatter"></el-table-column>
      <el-table-column prop="parameterValue" label="参数值"
                       :width="$system.calWidth(dataList, 'parameterValue', '参数值')"
                       header-align="left" align="left"></el-table-column>
      <el-table-column prop="parameterDescription" label="参数描述"
                       :width="$system.calWidth(dataList, 'parameterDescription', '参数描述', undefined, 360)"
                       header-align="left" align="left"></el-table-column>
      <el-table-column fixed="right" label="操作"
                       :min-width="$system.calMinWidth({ wordNum: 6, arrowNum: 1, btnNum: 4 })"
                       header-align="left" align="left">
        <template slot-scope="scope">
          <el-button class="zwx-button zwx-button-text-26" type="text" icon="el-icon-arrow-right"
                     @click="edit(scope.row)">编辑
          </el-button>
          <el-button class="zwx-button zwx-button-text-26"
                     :style="scope.row.ifEnable ? 'color: #e72b00 !important;' : ''" type="text"
                     @click="$system.msgbox(scope.row, '提示', scope.row.ifEnable ? '确定要停用吗？' : '确定要启用吗？', '确定', '取消', enable)"
          >{{ scope.row.ifEnable ? "停用" : "启用" }}
          </el-button>
          <el-button class="zwx-button zwx-button-text-26" type="danger"
                     @click="$system.msgbox(scope.row, '提示', '确定要删除吗？', '确定', '取消', deletion)"
                     v-if="!scope.row.ifEnable">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器部分 -->
    <base-pagination :parentPage="currentPage" :pageSize="pageSize" :total="total" @currentChange="currentChange" />
  </div>
</template>

<script>
export default {
  name: "ParamManage",
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      mainForm: {
        parameterKeyLike: "",
        ifEnables: [true]
      },
      dataList: [],
      currentPage: 1,
      pageSize: 18,
      total: 0
    };
  },
  created() {
  },
  mounted() {
    this.search(this.currentPage);
  },
  activated() {
    if (this.$route.params.fresh) this.search(this.currentPage);
  },
  computed: {},
  methods: {
    /**
     * 参数类型格式化
     */
    parameterTypeFormatter(row, column, cellValue) {
      if (this.$zwxBase.verifyIsBlank(cellValue)) {
        return "";
      }
      if (1 == cellValue) {
        return "文本";
      } else if (2 == cellValue) {
        return "布尔";
      } else if (3 == cellValue) {
        return "图片";
      }
    },
    currentChange(currentPage) {
      this.search(currentPage);
    },
    search(currentPage) {
      this.$emit("loading", true);
      this.currentPage = currentPage;
      let data = {
        currentPage: this.currentPage,
        parameterKeyLike: this.mainForm.parameterKeyLike,
        ifEnable: this.mainForm.ifEnables.length === 1 ? this.mainForm.ifEnables[0] : null
      };
      this.$system.get(this.api + "/systematic/getParameterList-1", data, true, true, this.searchSuccess, this.error);
    },
    searchSuccess(data) {
      if (data.type === "00") {
        this.dataList = data.parameterList;
        this.total = data.parameterCount;
        this.pageSize = data.pageSize;
      } else if (data.type === "99") {
        this.$router.push({ name: "ErrorPage", params: { mess: data.mess } });
      } else {
        this.$system.notify("错误", data.mess, "error");
      }
      this.$emit("loading", false);
    },
    enable(row) {
      this.$emit("loading", true);
      let data = { rid: row.rid, ifEnable: !row.ifEnable };
      this.$system.post(this.api + "/systematic/modifyParameterState-1", data, true, true, this.enableSuccess, this.error);
    },
    enableSuccess(data) {
      if (data.type === "00") {
        this.search(this.currentPage);
      } else if (data.type === "99") {
        this.$router.push({ name: "ErrorPage", params: { mess: data.mess } });
      } else {
        this.$system.notify("错误", data.mess, "error");
        this.$emit("loading", false);
      }
    },
    deletion(row) {
      this.$emit("loading", true);
      let data = { rid: row.rid };
      this.$system.post(this.api + "/systematic/deleteParameter-1", data, true, true, this.deletionSuccess, this.error);
    },
    deletionSuccess(data) {
      if (data.type === "00") {
        this.$system.notify("成功", data.mess, "success");
        this.search(this.currentPage);
      } else if (data.type === "99") {
        this.$router.push({ name: "ErrorPage", params: { mess: data.mess } });
      } else {
        this.$system.notify("错误", data.mess, "error");
        this.$emit("loading", false);
      }
    },
    add() {
      this.$router.push({ name: "ParamEdit", params: {} });
    },
    edit(row) {
      this.$router.push({ name: "ParamEdit", params: { rid: row.rid } });
    },
    error() {
      this.$system.notify("错误", "网络连接失败", "error");
      this.$emit("loading", false);
    }
  }
};
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
